import { StatusBar, Style } from '@capacitor/status-bar';
import Color from 'color';

/**
 * Sets the status bar style based on the background color.
 * The style will be set to 'DARK' if the background color is light,
 * and to 'LIGHT' if the background color is dark.
 */
export async function setStatusBarStyle(color) {
  try {
    if (!window.env.isApp) {
      return;
    }

    // Await directly for the getInfo promise to resolve
    // await StatusBar.getInfo();

    // Determine whether the color is light or dark, and set the style accordingly
    const style = Color(color).isLight() ? Style.Light : Style.Dark;

    // Apply the determined style to the status bar
    await StatusBar.setStyle({ style });
  } catch (error) {
    // Catch and log any error that occurs during the process
    console.warn('Error during AppBar color assignation:', error);
  }
}
